import { render } from "./StarRating.vue?vue&type=template&id=93a75418&scoped=true"
import script from "./StarRating.vue?vue&type=script&lang=js"
export * from "./StarRating.vue?vue&type=script&lang=js"

import "./StarRating.vue?vue&type=style&index=0&id=93a75418&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-93a75418"]])

export default __exports__